var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62891 8.6355L8.01172 6.11987H5.57812V4.47925C5.57812 3.76831 5.90625 3.11206 7 3.11206H8.12109V0.951904C8.12109 0.951904 7.10938 0.760498 6.15234 0.760498C4.15625 0.760498 2.84375 1.99097 2.84375 4.17847V6.11987H0.601562V8.6355H2.84375V14.7605H5.57812V8.6355H7.62891Z",
    fill: "#1C2539"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6071300e16cbc29813fb22e14ce81228.svg";
export { ForwardRef as ReactComponent };